import { useEffect } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const INTERVAL_MS = 10 * 60 * 1000;

// Periodic, coarse location ping — only when the carrier opted in. Server ignores it without an active trip.
const LocationReporter = () => {
  const { user, mode } = useAuth();
  const enabled = mode === "carrier" && !!user?.location_sharing_enabled && !!navigator.geolocation;
  useEffect(() => {
    if (!enabled) return undefined;
    const ping = () => navigator.geolocation.getCurrentPosition(
      (pos) => api.post("/users/me/location", { lat: pos.coords.latitude, lng: pos.coords.longitude }).catch(() => {}),
      () => {},
      { enableHighAccuracy: false, timeout: 15000, maximumAge: INTERVAL_MS },
    );
    ping();
    const iv = setInterval(ping, INTERVAL_MS);
    return () => clearInterval(iv);
  }, [enabled]);
  return null;
};

export default LocationReporter;
